// extracted by mini-css-extract-plugin
export default {"container":"LockedBanner_container__Ky5Gz","title":"LockedBanner_title__R-pTp font-sm-medium"};